module.exports = __webpack_public_path__ + "img/unavailable_billing.6ed4e1a9.svg";